import api from '~/api'

const state = {
  product: {},
}

const getters = {}

const mutations = {
  SET_PRODUCT(state, payload) {
    state.product = payload
  },
}

const actions = {
  async getSupplierProduct({ commit }, { supplierId, sku }) {
    const response = await api.get(`/suppliers/${supplierId}/products-sku/${sku}`)
    const [error, result] = response

    if (!error) {
      commit('SET_PRODUCT', result)
    }

    return response
  },
  createSupplierProduct({ commit }, { supplierId, form }) {
    return api.post(`/suppliers/${supplierId}/products`, form)
  },
  async updateSupplierProduct({ commit }, { supplierId, form }) {
    const response = await api.patch(
      `/suppliers/${supplierId}/products/${form.sku}`,
      form
    )

    const [error, result] = response

    if (!error) {
      commit('SET_PRODUCT', result)
    }

    return response
  },
  deleteSupplierProduct(_, { supplierId, sku }) {
    return api.delete(`/suppliers/${supplierId}/products/${sku}`)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
